import { render, staticRenderFns } from "./inspectionReport.vue?vue&type=template&id=36389814&scoped=true"
import script from "./inspectionReport.vue?vue&type=script&lang=js"
export * from "./inspectionReport.vue?vue&type=script&lang=js"
import style0 from "./inspectionReport.vue?vue&type=style&index=0&id=36389814&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36389814",
  null
  
)

export default component.exports